import { api } from "./api";
import { applyBrokerTimeZoneFromTimeInfo, isUsableIanaTimeZone } from "./dateFormats";

function resolveTimeInfoRequestUrl() {
  const base = String(api.defaults.baseURL || "/api/v1").replace(/\/+$/, "");
  if (/^https?:\/\//i.test(base)) return `${base}/common/TimeInfo`;
  if (base.startsWith("/")) return `${window.location.origin}${base}/common/TimeInfo`;
  return `${window.location.origin}/api/v1/common/TimeInfo`;
}

/** One public TimeInfo GET (no axios interceptors / crypto). */
export async function loadBrokerTimeZoneFromApi() {
  const url = resolveTimeInfoRequestUrl();
  const ctrl = typeof AbortController !== "undefined" ? new AbortController() : null;
  const timer = setTimeout(() => ctrl?.abort(), 4000);
  try {
    const res = await fetch(url, {
      method: "GET",
      credentials: "include",
      signal: ctrl?.signal,
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return "";
    const data = await res.json();
    const tz = applyBrokerTimeZoneFromTimeInfo(data);
    return isUsableIanaTimeZone(tz) ? tz : "";
  } catch {
    return "";
  } finally {
    clearTimeout(timer);
  }
}
